import React from 'react'
import { useParams } from 'react-router-dom'

import { Limb } from '../Limb'

import style from './Overview.scss'
import SkinTrack from './SkinTrack'
import SkinTracksContainer from './SkinTracksContainer'

const Overview = () => {
  const { customerId } = useParams<{ customerId: string }>()

  return (
    <div className={style.skinTracksContainer}>
      <SkinTracksContainer>
        {Object.values(Limb).map(limb => (
          <SkinTrack
            customerId={customerId}
            key={`stbutton${limb}`}
            limb={limb}
          />
        ))}
      </SkinTracksContainer>
    </div>
  )
}

export default Overview
